module.exports = __webpack_public_path__ + "img/photosession_1_1.cb868956.jpg";